import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconRokuReplayStyle0 = cosmosIconCss;

const CosmosIconRokuReplay$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRokuReplay extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3d916b2796277b3ef79278667b1802a5f2258f68', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '0fd0e22769d8e9b43372e78aec705d5a0bb5e273', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6b7b2468a846f9768e111f25ed2c8196912b9c1b', d: "M12.5 17.481A6.5 6.5 0 1 0 5.5 11v2.5H4V11a8 8 0 1 1 8.5 7.985.477.477 0 0 1-.5-.485V18c0-.276.225-.498.5-.519Z", fill: "currentColor" }), h("path", { key: 'bad68397092fda469e913f47a9ae7b43b49f97aa', d: "M8.168 13.555a.4.4 0 0 0-.384-.245l-5.98.01a.4.4 0 0 0-.29.68l3 3a.4.4 0 0 0 .56 0l3-3a.4.4 0 0 0 .094-.445Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconRokuReplayStyle0; }
}, [1, "cosmos-icon-roku-replay", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-roku-replay"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-roku-replay":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRokuReplay$1);
            }
            break;
    } });
}

const CosmosIconRokuReplay = CosmosIconRokuReplay$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRokuReplay, defineCustomElement };
